"use client";

import Link from "next/link";
import Checkbox from "./Checkbox";
import { useState } from "react";
import { MdOpenInNew } from "react-icons/md";
import { useStaticStore } from "app/hooks";
import { STORE_KEYS } from "app/constants";
import { SiteSettingModel } from "@api/models";

export function PopupContentLegal({
  date,
  url,
  onAgree,
  siteSettings,
}: {
  date: string;
  url: string;
  onAgree: () => Promise<void>;
  siteSettings: SiteSettingModel;
}) {
  const [checked, setChecked] = useState(false);
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.popup);
  const [isSending, setIsSending] = useState(false);
  const handleSubmit = () => {
    setIsSending(true);
    onAgree()
      .then(() => {
        setIsSending(false);
        setIsOpen(false);
      })
      .catch(() => {
        setIsSending(false);
        //TODO:エラー時どうするか決める
      });
  };

  return (
    <div>
      <h2 className="dialog-h">利用規約が変更されました</h2>
      <p className="dialog-desc">
        {siteSettings.name}を引き続きご利用いただくには、 新しい利用規約をお読みの上、
        同意いただく必要があります。
      </p>
      <Link className="dialog-term-link" target="_blank" href={url}>
        <span className="dialog-term-link-label">
          利用規約
          <MdOpenInNew className="dialog-term-link-icon" size={24} />
        </span>
        <span className="dialog-term-link-date">({date}改訂)</span>
      </Link>
      <br />
      <div className="dialog-chk-wrap mode-legal">
        <Checkbox
          label={<span className="dialog-legal-label">利用規約の内容を確認しました</span>}
          checked={checked}
          onChange={() => setChecked((prev) => !prev)}
        />
      </div>
      <div className="dialog-btns mode-last">
        <button
          type="submit"
          className="dialog-btn mode-primary"
          onClick={() => {
            handleSubmit();
          }}
          disabled={!checked || isSending}
        >
          利用規約に同意して利用する
        </button>
      </div>
    </div>
  );
}
